// apiEndpoint must come from useRegionConfig() so the request hits the correct
// regional deployment — each region serves files from its own S3 bucket.

export function buildContentImageUrl(args: {
  apiEndpoint: string;
  workspaceId: string | number;
  imageId: string;
}): string {
  const key = `${args.workspaceId}/images/${args.imageId}`;
  return `${args.apiEndpoint}/agents/files?key=${encodeURIComponent(key)}`;
}

export function buildContentImageThumbnailUrl(args: {
  apiEndpoint: string;
  workspaceId: string | number;
  imageId: string;
  width: number;
}): string {
  const key = `${args.workspaceId}/images/${args.imageId}`;
  return `${args.apiEndpoint}/agents/files?key=${encodeURIComponent(key)}&width=${args.width}&format=webp`;
}
